import React, { useEffect, useState } from "react";
import VehicleStateDisplay from "@components/VehicleDashboard/vehicleState/VehicleStateDisplay.js"
import "./VehicleStateDisplayArray.css";

export default function VehicleStateDisplayArray({ vehicle }) {
const [vehicleState, setVehicleState] = useState("");

  useEffect(() => {
    setVehicleState(vehicle.state);
  }, [vehicle]);

  return (
    <>
      <VehicleStateDisplay className="emergency" vehicleState={vehicleState} stateLabel="Emergency" />
      <VehicleStateDisplay className="vehicleStateDisplay-instance" vehicleState={vehicleState} stateLabel="Parking" />
      {/* <VehicleStateDisplay className="vehicleStateDisplay-instance" vehicleState={vehicleState} stateLabel="Manual" /> */}
      <VehicleStateDisplay className="vehicleStateDisplay-instance" vehicleState={vehicleState} stateLabel="Autonomous" />
      {/* <VehicleStateDisplay className="vehicleStateDisplay-instance" vehicleState={vehicleState} stateLabel="Docking" /> */}
      <VehicleStateDisplay className="vehicleStateDisplay-instance" vehicleState={vehicleState} stateLabel="Driving" />
      <VehicleStateDisplay className="vehicleStateDisplay-instance" vehicleState={vehicleState} stateLabel="Maintenance" />
    </>
  );
}

